// Modal-level state for CreateLearnerModal — whether the account has a
// learner to fall back to (so "Save & exit" can show), and the HOP-135
// parental-consent gate. Extracted out of the component so it stays
// presentation-only.

import { useState } from 'react'
import { useLearners } from '@/hooks/useLearners'

export function useCreateLearnerModal() {
  // First-run wall: with no learners on the account there is nothing to
  // exit TO — the app needs at least one reader. "Save & exit" only appears
  // when the account already has a learner to fall back to (the
  // add-another path from the learner switcher).
  const { learners } = useLearners()
  const canExit = learners.length > 0

  // HOP-135: resets to false on every mount, same as the reader-card form
  // fields — consent is per add-learner session, not remembered across them.
  const [consented, setConsented] = useState(false)

  return { canExit, consented, setConsented }
}
